import { getAuthToken, isAuthTokenExpired } from '@cash-rewards/reactjs';
import { useCallback } from 'react';

import { UPDATE_FAV_STORES_PATH } from '@/constants/api';
import { useFetcherWithToken } from '@/modules/core/hooks/useFetcherWithToken';
import { useAppContext } from '@/modules/core/providers/appConfigProvider';

const useUpdateFavouriteStore = () => {
  const { API_URL } = useAppContext();
  const fetcher = useFetcherWithToken();

  const updateFavouriteStore = useCallback(
    async (merchantId: number, isFavourite: boolean) => {
      const token = await getAuthToken();
      if (!token || isAuthTokenExpired()) {
        const url = `${window.location.pathname}${window.location.search}`;
        const returnUrl = encodeURIComponent(url);
        window.location.href = `/Login?ReturnUrl=${returnUrl}`;
      }
      const url = `${API_URL}${UPDATE_FAV_STORES_PATH}`;
      return fetcher(url, {
        method: isFavourite ? 'PUT' : 'DELETE',
        data: {
          merchantIds: [merchantId],
        },
      });
    },
    [API_URL, fetcher]
  );

  return { updateFavouriteStore };
};

export default useUpdateFavouriteStore;
